import React from 'react';
import {
  Field,
  FieldContent,
  FieldDescription,
  FieldLabel,
  FieldTitle,
} from '@/components/ui/field';
import { cn } from '@/utilities/cn';

type PlayerSelectorRowProps = {
  controlId: string;
  isSelected: boolean;
  isDisabled?: boolean;
  title: React.ReactNode;
  description?: React.ReactNode;
  avatar: React.ReactNode;
  control: React.ReactNode;
  onClick?: () => void;
};

const PlayerSelectorRow: React.FC<PlayerSelectorRowProps> = ({
  controlId,
  isSelected,
  isDisabled = false,
  title,
  description,
  avatar,
  control,
  onClick,
}) => {
  return (
    <FieldLabel
      htmlFor={controlId}
      className={cn(
        'cursor-pointer rounded-lg border bg-card p-3 transition-colors',
        isSelected
          ? 'border-primary bg-primary/10'
          : 'border-border hover:border-primary/60',
        isDisabled && 'cursor-not-allowed opacity-50'
      )}
      onClick={onClick}
    >
      <Field orientation="horizontal" data-disabled={isDisabled}>
        {control}
        {avatar}
        <FieldContent>
          <FieldTitle>{title}</FieldTitle>
          {description && <FieldDescription>{description}</FieldDescription>}
        </FieldContent>
      </Field>
    </FieldLabel>
  );
};

export default PlayerSelectorRow;
